export enum WeightLevel {

    LEVEL_1 = 'SD3-',
    LEVEL_2 = 'SD2-',
    LEVEL_3 = 'SD1-',
    LEVEL_4 = 'SD0',
    LEVEL_5 = 'SD1',
    LEVEL_6 = 'SD2',
    LEVEL_7 = 'SD3',
    NO_MEASURED = 'No medido',
    LOW_LEVEL_INDICATOR = 'Bajo peso severo',
    MIDDLE_LOW_LEVEL_INDICATOR = 'Bajo peso moderado',
    NORMAL_LEVEL = 'Normal',
    PROBABLY_OVERWEIGHT = 'Probable obesidad',
    OBESITY = 'Obesidad',
    UNKNOWN_LEVEL = 'none'

}
